import React from 'react';
import styled, { css } from 'styled-components';

import Clickable from '@prisjakt/ui-clickable';
import { TitleSmallText } from '@prisjakt/ui/text/variants';

import { layout, colorUtils } from '@prisjakt/ui-base';

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
  to?: string;
};

export const Pill = (props: Props) => {
  const { children, onClick, to } = props;

  return (
    <StyledPill to={to} onClick={onClick}>
      <TitleSmallText>{children}</TitleSmallText>
    </StyledPill>
  );
};

const { spacingSmall, spacingNormal } = layout.measurements;

export const StyledPill = styled(Clickable)(
  p => css`
    margin: ${layout.measurements.spacingTiny};
    background-color: ${p.theme.colors.yellove300};
    border-radius: 100px;
    padding: ${spacingSmall} ${spacingNormal};
    white-space: nowrap;
    transition: background-color 150ms ease;

    &:hover {
      background-color: ${colorUtils.shadeColor(
        p.theme.colors.yellove300,
        -10
      )};
      cursor: pointer;
    }
  `
);
